module.exports = __webpack_public_path__ + "img/vue1-renfort_bleu.355e7d21.png";